Ext.ns('mx.app.widget');

mx.app.widget.DispatchSheetPanel = Ext.extend(Ext.Panel, {
    layout: 'border',
    border: false,
    header: false,
    centralPanelId: 'dispatchsheetpanel',
    initComponent: function() {
        mx.app.widget.DispatchSheetPanel.superclass.initComponent.apply(this, arguments);
        this.centralPanel = new this.centralPanelClass({
            region: 'center',
            id: this.centralPanelId,
        });
        if (this.upperPanelClass) {
            this.upperPanel = new this.upperPanelClass({
                region: 'north',
                centralPanelClass: this.centralPanel,
                margins: {
                    left: 10,
                    top: 10,
                    right: 10,
                    bootom: 10,
                },
                applyClick: this.centralPanel.filterHandler.createDelegate(this.centralPanel),
            });
            this.centralPanel.form = this.upperPanel;
            this.add(this.upperPanel);
        }

        this.add(this.centralPanel);
    },
});
